import React from "react";
import { useTheme } from "@mui/material";
import styled from "@emotion/styled";
import UMMOConfig from "config";
import ProductCard from "components/ProductCard";

function CardContainer() {
  const theme = useTheme();
  return (
    <FlexWrapper style={{ "--blackish": theme.palette.blackish.main, "--whitish": theme.palette.whiteish.main }}>
      {UMMOConfig.products?.map((product) => (
        <ProductCard product={product} key={product.name} />
      ))}
    </FlexWrapper>
  );
}

const FlexWrapper = styled.div`
  background: linear-gradient(
    180deg,
    var(--blackish) 70.55%,
    var(--whitish) 0
  ); //% calculated based on expanded and collapsed card height
  min-height: var(--expanded-card-height);
  flex-shrink: 0;

  display: flex;
  align-items: end;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5.938rem;
`;

export default CardContainer;
